import * as actionTypes from 'store/actions/actionTypes';
import { writeQRcode } from 'store/actions/QRcode';

const writeCart = (productType, records) => ({ type: actionTypes.WRITE_CART_END, productType, records });

export const updateCart = (productType, records) => {
  return dispatch => {
    return dispatch(writeCart(productType, records));
  };
};

export const trimCart = (type, id) => {
  return dispatch => {
    return dispatch({
      type: actionTypes.TRIM_CART_END,
      product_type: type,
      product_id: id,
    });
  };
};

export const clearCart = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.CLEAR_CART_END,
    });
};

export const sendToQRcode = cartData => {
  return (dispatch, getState) => {
    const { QRcode, setting } = getState();
    // qr_codes ids
    const qrID = QRcode.items.map(e => e.id);
    // cartdata ids
    const cdID = cartData.map(e => e.id);
    // intersection of qr_code ids and cartdata ids
    const intersection = qrID.filter(e => cdID.indexOf(e) !== -1);
    if (intersection.length > 0) return intersection;
    else {
      dispatch(writeQRcode(cartData, setting.settings));
      dispatch(clearCart());
      return [];
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/cart.js